import { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

import { getNavigationUrls } from 'hb-react/shared/components/FilePreview/utils/previewUrl';

export const useFilePreviewNavigation = ({
  files,
  closePreviewUrl,
  getFileUrl,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { fileUuid, userId } = useParams();
  const [navigation, setNavigation] = useState({
    nextUrl: null,
    previousUrl: null,
    nextFile: null,
  });
  const [hasPagination, setHasPagination] = useState(false);

  useEffect(() => {
    if (files) {
      setHasPagination(true);
      const { nextUrl, previousUrl, nextFile } = getNavigationUrls({
        files,
        uuid: fileUuid,
        getFileUrl,
      });

      setHasPagination(Boolean(previousUrl || nextUrl));
      setNavigation({ nextUrl, previousUrl, nextFile });
    }
  }, [files, fileUuid, userId]);

  const onSwipedLeft = () => {
    navigate(
      `${navigation.nextUrl || closePreviewUrl}?${searchParams.toString()}`,
    );
  };

  const onSwipedRight = () => {
    navigate(
      `${navigation.previousUrl || closePreviewUrl}?${searchParams.toString()}`,
    );
  };

  const handleKeyNavigation = (keyCode) => {
    const { nextUrl, previousUrl } = navigation;
    switch (keyCode) {
      case 39: // Right
        if (nextUrl) {
          navigate(`${nextUrl}?${searchParams.toString()}`);
        }
        break;
      case 37: // Left
        if (previousUrl) {
          navigate(`${previousUrl}?${searchParams.toString()}`);
        }
        break;
      default:
    }
  };

  return {
    ...navigation,
    hasPagination,
    handleKeyNavigation,
    onSwipedLeft,
    onSwipedRight,
  };
};
